<template>
  <div id="app">
    <!-- 路由占位符 -->
    <router-view></router-view>
  </div>
</template>

<script>
export default {}
</script>

<style lang="stylus">
// ::-webkit-scrollbar 滚动条整体部分，可以设置宽度啥的
// ::-webkit-scrollbar-button 滚动条两端的按钮
// ::-webkit-scrollbar-track 外层轨道
// ::-webkit-scrollbar-track-piece 内层滚动槽
// ::-webkit-scrollbar-thumb 滚动的滑块
// ::-webkit-scrollbar-corner 边角
// ::-webkit-resizer 定义右下角拖动块的样式
// :horizontal//适用于任何水平方向上的滚动条

// :vertical//适用于任何垂直方向的滚动条
// :decrement//适用于按钮和轨道碎片。表示递减的按钮或轨道碎片，例如可以使区域向上或者向右移动的区域和按钮
// :increment//适用于按钮和轨道碎片。表示递增的按钮或轨道碎片，例如可以使区域向下或者向左移动的区域和按钮
// :start//适用于按钮和轨道碎片。表示对象（按钮轨道碎片）是否放在滑块的前面
// :end //适用于按钮和轨道碎片。表示对象（按钮轨道碎片）是否放在滑块的后面
// :double-button//适用于按钮和轨道碎片。判断轨道结束的位置是否是一对按钮。也就是轨道碎片紧挨着一对在一起的按钮。
// :single-button//适用于按钮和轨道碎片。判断轨道结束的位置是否是一个按钮。也就是轨道碎片紧挨着一个单独的按钮。
// :no-button//表示轨道结束的位置没有按钮。
// :corner-present//表示滚动条的角落是否存在。
// :window-inactive//适用于所有滚动条，表示包含滚动条的区域，焦点不在该窗口的时候。
.csn-scrollbar
  overflow-y auto
.csn-scrollbar::-webkit-scrollbar
  width 8px
  height 0
  cursor pointer
.csn-scrollbar::-webkit-scrollbar-thumb
  border-radius 4px
  -webkit-box-shadow inset 0 0 4px rgba(0, 0, 0, 0.1)
  background #e6e6e6
.csn-scrollbar-x
  overflow-x auto
.csn-scrollbar-x::-webkit-scrollbar
  width 0
  height 8px
  cursor pointer
.csn-scrollbar-x::-webkit-scrollbar-thumb
  border-radius 4px
  -webkit-box-shadow inset 0 0 4px rgba(0, 0, 0, 0.1)
  background #e6e6e6
// body::-webkit-scrollbar
// width 4px
// body::-webkit-scrollbar-thumb
// background transparent
// background rgba(136, 136, 136, 0.4)
// border-radius 4px
// body::-webkit-scrollbar-track
// background transparent
// // background rgba(136, 136, 136, 0.1)
// body:hover::-webkit-scrollbar-thumb
// background rgba(136, 136, 136, 0.6)
// body:hover::-webkit-scrollbar-track
// background rgba(136, 136, 136, 0.1)
html, body, div, p, ul, li, a
  margin 0
  padding 0
  font-family 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', '微软雅黑', Arial, sans-serif
body
  background-color #F0F2F5
ul li
  list-style none
a
  text-decoration none
.no-select
  user-select none
  -moz-user-select none /* Firefox 特有 */
  -webkit-user-select none /* Safari 和 Chrome 特有 */
  -ms-user-select none /* IE/Edge 特有 */
.ellipsis
  white-space nowrap
  overflow hidden
  text-overflow ellipsis
:root
  --color-main #409EFF
  --color-main-light #FFF5ED
.el-button.el-button--default
  &:hover, &:focus
    color var(--color-main)
    border-color var(--color-main-light)
    background-color var(--color-main-light)
.el-dialog__wrapper
  display flex
  align-items center
  justify-content center
  padding 20px 0
.el-dialog
  margin auto !important
  border-radius 1% !important
  &.header-line .el-dialog__header
    border-bottom 1px solid rgba(0, 0, 0, 0.04)
  .el-dialog__header
    .el-dialog__headerbtn
      top 0
      right 0
      .el-dialog__close
        font-size 22px
        padding 15px
        &:hover
          color var(--color-main)
  .el-dialog__body
    .warning
      position absolute
      top 25px
      left 100px
      color #ee6869
  .el-dialog__footer
    padding-top 0
    padding-bottom 30px
    .dialog-footer
      display flex
      justify-content center
      .el-button
        width 100px
      .el-button+.el-button
        margin-left 40px
.el-switch.is-checked .el-switch__core, .el-radio__input.is-checked .el-radio__inner, .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner, .el-radio-button__orig-radio:checked+.el-radio-button__inner
  border-color var(--color-main) !important
  background-color var(--color-main) !important
.el-radio-button__orig-radio:checked+.el-radio-button__inner
  box-shadow -1px 0 0 0 var(--color-main) !important
.el-checkbox__input:hover .el-checkbox__inner, .el-checkbox__input.is-focus .el-checkbox__inner, .el-radio__input:hover .el-radio__inner
  border-color var(--color-main) !important
.el-radio__input.is-checked+.el-radio__label, .el-select-dropdown__item.selected, .el-checkbox__input.is-checked+.el-checkbox__label, .el-radio-button__inner:hover
  color var(--color-main) !important
.is-active .el-radio-button__inner
  color #fff !important
.el-select-dropdown__item.hover, .el-select-dropdown__item:focus
  background-color var(--color-main-light) !important
.el-popover.csn-popover
  color #666
  font-size 14px
  padding 6px 0
  min-width auto
  ul
    li
      &.normal
        margin 0 4px
        line-height 22px
        padding 5px 16px
        cursor pointer
        &.active
          color var(--color-main)
          font-weight bold
        &:hover
          color var(--color-main)
          background-color var(--color-main-light)
      &.line
        height 1px
        background-color #eee
        margin 6px 0
.label-comment
  display flex
  align-items center
  gap 5px
  div.comment
    width 14px
    height 14px
    line-height 14px
    border-radius 50%
    color #aaa
    font-size 12px
    text-align center
    border 1px solid #aaa
    box-sizing border-box
    cursor pointer
</style>
